<template>
  <div id="app">
    <custom-winwheel :blok="winwheel" v-if="winwheelVisibility && winwheel" />
    <component :is="layout">
      <transition name="transition">
        <router-view :key="$route.path" class="current-view" />
      </transition>
    </component>
    <ShopToast></ShopToast>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import i18n from "./i18n";

export default {
  data() {
    return {
      toolbarClass: "top",
      ticking: false
    };
  },
  computed: {
    layout() {
      return ((this.$route.meta && this.$route.meta.layout) || "default") + "-layout";
    },
    winwheel() {
      return this.$store.getters.winwheel;
    },
    winwheelVisibility() {
      return localStorage.getItem("winwheel") ? false : true;
    },
    ...mapGetters(["settings"])
  },
  created() {
    this.$store.dispatch("fetchSettings");
    this.$store.dispatch("fetchMenus");
    this.$store.dispatch("fetchSubmenus");
    this.$store.dispatch("fetchWinwheel");
    //this.$moment.locale(i18n.locale);
    //console.log("settings", this.settings);
    /*if (this.settings.chat_script) {
      var script_tag = document.createElement("script");
      script_tag.type = "text/javascript";
      script_tag.text = this.settings.chat_script;
      document.body.appendChild(script_tag);
    }*/
  },
  methods: {
    checkViewport(e) {
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          if (this.height > 800) {
            if (window.scrollY > this.height - 540) {
              this.toolbarClass = "bottom";
            } else {
              this.toolbarClass = "top";
            }
            this.ticking = false;
          } else {
            if (window.scrollY > this.height - 540) {
              this.toolbarClass = "bottom";
            } else {
              this.toolbarClass = "top";
            }
            this.ticking = false;
          }
        });
      }
      this.ticking = true;
    }
  },
  mounted() {
    window.addEventListener("OsvCartChange", payload => {
      if (payload.detail.diff > 0) {
        this.$store.commit("OPEN_SHOP_TOAST");
        setTimeout(() => {
          this.$store.commit("CLOSE_SHOP_TOAST");
        }, 5000);
      }
    });
    // load crisp
    let prerendering = window.__PRERENDER_INJECTED;
    if (!prerendering) {
      // when the app is prerendered, window.__PRERENDER_INJECTED is injected in pupeteer, we do not load crsip in this prerendering task because it creates dom and load script but break crisp totally
      setTimeout(() => {
        console.log("check crisp");
        try {
          if (window.$crisp == null) {
            console.log("load crisp");
            window.$crisp = [];
            window.CRISP_WEBSITE_ID = "12487620-d486-4f57-b13e-bcc174559f79";
            (function() {
              let d = document;
              let s = d.createElement("script");
              s.src = "https://client.crisp.chat/l.js";
              s.async = 1;
              d.getElementsByTagName("head")[0].appendChild(s);
            })();
            window.CRISP_READY_TRIGGER = async function() {
              console.log("crisp ready");
            };
          }
        } catch (error) {
          console.log("error while loading crisp " + error);
        }
        // we wait for one second before loading crisp because of the spa cache renderer which reloads the dom after mount....
      }, 1000);
    }
  },
  beforeMount() {
    window.addEventListener("scroll", this.checkViewport);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.checkViewport);
  }
};
</script>

<style lang="scss">
/*.current-view {
}
.transition-leave-active,
.transition-enter-active {
  transition: 0.5s;
}
.transition-enter {
  transform: translate(100%, 0);
  opacity: 0.4;
}
.transition-leave-to {
  transform: translate(-100%, 0);
  opacity: 1;
}*/
</style>
